import PROFIL_ECRITURE from '../../../constants/mouvements/codeProfilEcritures';
import CompteDeTiersPanel from '../panel/CompteDeTiersPanel';
import CovidPanel from '../panel/CovidPanel';
import DelaiPaiementPanel from '../panel/DelaiPaiementPanel';
import FctvaPanel from '../panel/FctvaPanel';
import InformationsChorusProPanel from '../panel/InformationsChorusProPanel';
import SaisieLibrePanel from '../panel/InformationsRattachement/SaisieLibrePanel';
import InventairePanel from '../panel/InventairePanel';
import NumeroEmpruntPanel from '../panel/NumeroEmpruntPanel';
import PeriodeCouvertePanel from '../panel/PeriodeCouvertePanel';
import ProjetPanel from '../panel/ProjetPanel';
import RegiePanel from '../panel/RegiePanel';
import TravauxEnRegiePanel from '../panel/TravauxEnRegiePanel';
import TypologiePesPanel from '../panel/TypologiePesPanel';
import BaseProfilEcritureDepense from './Base/BaseProfilEcritureDepense';

class ProfilEcritureLibreDepense extends BaseProfilEcritureDepense {
	constructor() {
		super();
		this.code = PROFIL_ECRITURE.DEPENSE.SAI_LIB;
		this.panels = [
			new CompteDeTiersPanel(),
			new CovidPanel(),
			new DelaiPaiementPanel(),
			new FctvaPanel(),
			new InformationsChorusProPanel(),
			new InventairePanel(),
			new NumeroEmpruntPanel(),
			new PeriodeCouvertePanel(),
			new ProjetPanel(),
			new RegiePanel(),
			new TravauxEnRegiePanel(),
			new TypologiePesPanel(true),
			new SaisieLibrePanel(),
			// TODO : add "Marche public" optional panel
			// TODO : add "Nomenclature achat" optional panel
		];
	}
}

export default ProfilEcritureLibreDepense;
